import { CommonModule } from "@angular/common";
import { Component, ElementRef, HostListener, inject, ViewChild } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { map } from "rxjs";
import { SubpageHeaderComponent } from "../../components/subpage-header/subpage-header.component";
import { BackgroundImageDirective } from "../../core/directives/background-image.directive";
import { AnalyticsService } from "../../core/services/analytics.service";

@Component({
    selector: "grainger-contracts",
    imports: [CommonModule, SubpageHeaderComponent, RouterModule, BackgroundImageDirective],
    templateUrl: "./contracts.component.html",
    styleUrl: "./contracts.component.scss"
})
export class ContractsComponent {
    @ViewChild("tabsEl") tabs!: ElementRef<HTMLDivElement>;
    public tabScrolled: boolean = false;

    private route = inject(ActivatedRoute);
    public contractType = this.route.params.pipe(map((params) => params["contractType"] as string));
    private analyticsService = inject(AnalyticsService);

    public trackHeaderClick(label: string): void {
        this.analyticsService.trackInteraction({
            action: "click",
            location: "Contracts Page Header",
            category: "button",
            label
        });
    }

    public trackTabClick(label: string, location?: string): void {
        this.analyticsService.trackInteraction({
            action: "click",
            location: location
                ? `Contracts Page - ${location.charAt(0).toUpperCase() + location.slice(1)}`
                : "Contracts Page",
            category: "button",
            label
        });
    }

    @HostListener("window:scroll", ["$event"])
    onWindowScroll(event: Event): void {
        this.handleTabScroll();
    }

    public handleTabScroll(): void {
        const el = this.tabs.nativeElement;

        const rect = el.getBoundingClientRect();
        const styleTop = parseInt(window.getComputedStyle(el).top, 10);

        const threshold = styleTop;

        this.tabScrolled = rect.top <= threshold || rect.top - threshold <= 1;
    }
}
